import { Theme } from '@material-ui/core';

export const muiPickerOverrides = (theme: Theme) =>
  ({
    MuiPickersDay: {
      current: {
        color: theme.palette.text.primary,
        border: `solid 1px ${theme.palette.text.primary}`,
      },
    },
  } as Theme['overrides']);
